

























import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ISignDocument } from "@/models/sign-document.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";

@Component({
  components: {
    ConfirmActionDialog
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class DocumentManageAccessDialog extends mixins(PermissionMixin) implements IDialog {
  @Prop({ default: null })
  value!: ISignDocument | null;

  @PropSync("isDialogActive", { type: Boolean, default: false })
  dialog!: boolean;

  loading = false;
  isInternal = true;

  @Watch("dialog", { immediate: true })
  onValueChanged() {
    if (!this.value) {
      this.isInternal = true;
      return;
    }

    this.isInternal = this.value.isInternal;
  }

  open(): void {
    this.dialog = true;
  }

  close(): void {
    this.dialog = false;
  }

  async updateIsInternal() {
    if (!this.canUpdateDocument) {
      return;
    }
    if (!this.value) {
      return;
    }

    try {
      this.loading = true;
      await this.value.updateIsInternal(this.isInternal);

      this.dialog = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
